import { groupBy } from 'lodash';
import { ActiveStatus, Cause, Issue, SolutionGridItem } from '../types';

export const mapSolutionGrid = (solutionGrid: SolutionGridItem[]) => {
  const groupedSolutionGrid = groupBy(solutionGrid, 'causeID');

  const solutionGridByCause = Object.keys(groupedSolutionGrid).map((key) => ({
    causeID: key,
    causeName: groupedSolutionGrid[key][0].causeName,
    issues: groupedSolutionGrid[key],
  }));

  return solutionGridByCause;
};

export const initSolutionGrid = ({
  issues,
  causes,
  templateID,
  existingSolutionGrids,
  versionID,
}: {
  issues: Issue[];
  causes: Cause[];
  templateID: string;
  existingSolutionGrids: SolutionGridItem[];
  versionID?: string | number;
}) => {
  const newSolutionGrid: SolutionGridItem[] = [];
  const updatedSolutionGrid: SolutionGridItem[] = [];

  causes.forEach(({ causeID, name: causeName }) => {
    issues.forEach(({ issueID, name: issueName }) => {
      const existedItem = existingSolutionGrids.find(
        (i) =>
          String(i.causeID) === String(causeID) &&
          String(i.issueID) === String(issueID)
      );
      if (existedItem) {
        updatedSolutionGrid.push(existedItem);
      } else {
        newSolutionGrid.push({
          gridID: `${causeID}-${issueID}`,
          causeID: String(causeID),
          causeName,
          issueID: String(issueID),
          issueName,
          templateID,
          activeStatus: ActiveStatus.ACTIVE,
          versionID: versionID || '',
        });
      }
    });
  });

  return {
    newSolutionGrid,
    updatedSolutionGrid,
  };
};
